// FOR REVIEW - review this whole file and all it's endpoints
// src/store.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "services/axios-supabase";
import _ from "lodash";

// ------------------------------------------------------------------------
// Initial state
const initialState = {
  logs: [],
  loading: false,
  error: null,
  logsLoaded: false,
  nextPage: null,
  hasNextPage: false,
  category: "",
};

export const selectLogsLoaded = (state) => state.logReducer.logsLoaded;

export const fetchLogs = createAsyncThunk(
  "data/fetchLogs",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState().logReducer;
      const response = await axiosInstance.get("/logs", {
        params: { ...params, category: state.category },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const loadMore = createAsyncThunk(
  "data/loadMore",
  async (_, { getState, rejectWithValue }) => {
    const state = getState().logReducer;

    if (!state.hasNextPage || !state.nextPage) {
      return { data: [], pagination: { has_next_page: false } };
    }

    try {
      const response = await axiosInstance.get("/logs", {
        params: {
          page: state.nextPage,
          category: state.category,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ------------------------------------------------------------------------
// Slices

export const LogSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setCategory: (state, action) => {
      state.category = action.payload.category;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.data || [];
        state.logsLoaded = true;
        state.nextPage = action.payload.pagination?.has_next_page
          ? action.payload.pagination.next_page
          : null;
        state.hasNextPage = Boolean(action.payload.pagination?.has_next_page);
      })
      .addCase(fetchLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(loadMore.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadMore.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = [...(state.logs || []), ...(action.payload.data || [])];
        state.nextPage = action.payload.pagination?.has_next_page
          ? action.payload.pagination.next_page
          : null;
        state.hasNextPage = Boolean(action.payload.pagination?.has_next_page);
      })
      .addCase(loadMore.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducers
export const { setLoading, setError, setCategory } = LogSlice.actions;

// ------------------------------------------------------------------------
// Configure store

export default LogSlice.reducer;
